import { gql } from '@apollo/client';

export const GET_STUDENT_LIST = gql`
  query SkWeb_StudentList_1(
    $username: String
    $studentId: ID
    $schoolId: ID
    $productId: ID
    $classroomId: ID
    $page: Int
    $pageSize: Int
    $sortBy: String
    $order: String
  ) {
    studentList(
      username: $username
      studentId: $studentId
      schoolId: $schoolId
      productId: $productId
      classroomId: $classroomId
      page: $page
      pageSize: $pageSize
      sortBy: $sortBy
      order: $order
    ) {
      data {
        id
        name
        username
        englishName
        school {
          id
          name
        }
        product {
          id
          name
        }
        classroom {
          id
          name
          courses {
            product {
              id
              name
            }
            level
          }
        }
        hwDoneRate
        avgCheckGrade
        notDoneHW
        lastLogin
        coinInfo {
          coins
          totalUsedCoins
          currentCoins
        }
      }
      totalCount
    }
  }
`;
